import { useState, useEffect, useRef, useMemo } from "react";
import { WALLS } from "./map1";
import { findGhostPath } from "./findGhostPathUtils";
import Player from "components/quiz/questions/iserba/player/Player";
import SplashScreen from "../SplashScreen";
import GameEndScreen from "../GameEndScreen";
import { MdOutlineExitToApp } from "react-icons/md";
import { iconMap } from "components/quiz/questions/iserba/gameIconsUtils";
import borne_arcade from "assets/puzzles/iserba/pacman/borne_arcade.svg";
import ScrollingItems from "./ScrollingItems";
import Loader from "components/shared/Loader";
import { playerSpriteSets } from "../player/playerIconsUtils";

const ROWS = 24;
const COLS = 17;

const SUBDIVISIONS = 7; // Each cell is subdivided into a grid
const SUB_ROWS = ROWS * SUBDIVISIONS;
const SUB_COLS = COLS * SUBDIVISIONS;

const MOVEMENT_SPEED = 50;
const GHOST_SPEED = 80;

const SPAWN_ZONE = [
	{
		x: 8 * SUBDIVISIONS + Math.floor(SUBDIVISIONS / 2),
		y: 10 * SUBDIVISIONS + Math.floor(SUBDIVISIONS / 2),
	},
	{
		x: 8 * SUBDIVISIONS + Math.floor(SUBDIVISIONS / 2),
		y: 11 * SUBDIVISIONS + Math.floor(SUBDIVISIONS / 2),
	},
	{
		x: 8 * SUBDIVISIONS + Math.floor(SUBDIVISIONS / 2),
		y: 12 * SUBDIVISIONS + Math.floor(SUBDIVISIONS / 2),
	},
	{
		x: 8 * SUBDIVISIONS + Math.floor(SUBDIVISIONS / 2),
		y: 13 * SUBDIVISIONS + Math.floor(SUBDIVISIONS / 2),
	},
	{
		x: 8 * SUBDIVISIONS + Math.floor(SUBDIVISIONS / 2),
		y: 14 * SUBDIVISIONS + Math.floor(SUBDIVISIONS / 2),
	},
];

const SPAWN_EXIT_POSITION = {
	x: 9 * SUBDIVISIONS + Math.floor(SUBDIVISIONS / 2),
	y: 12 * SUBDIVISIONS + Math.floor(SUBDIVISIONS / 2),
};

const EXIT_POSITION = {
	x: 13 * SUBDIVISIONS + Math.floor(SUBDIVISIONS / 2),
	y: 19 * SUBDIVISIONS + Math.floor(SUBDIVISIONS / 2),
};

const isWall = (x, y) => WALLS.some((wall) => wall.x === x && wall.y === y);

const generateSubPathGrid = () => {
	let subPathList = [];

	for (let row = 0; row < ROWS; row++) {
		for (let col = 0; col < COLS; col++) {
			if (isWall(col, row)) continue; // Skip walls

			// Define the base position in the subdivided grid
			const baseX = col * SUBDIVISIONS;
			const baseY = row * SUBDIVISIONS;

			// Define the center of the subdivided cell
			const centerX = baseX + Math.floor(SUBDIVISIONS / 2);
			const centerY = baseY + Math.floor(SUBDIVISIONS / 2);

			// Add center point
			subPathList.push({ x: centerX, y: centerY });

			// Directions: Top, Bottom, Left, Right
			const directions = [
				{ dx: 0, dy: -1, wallCheck: { x: col, y: row - 1 } }, // Up
				{ dx: 0, dy: 1, wallCheck: { x: col, y: row + 1 } }, // Down
				{ dx: -1, dy: 0, wallCheck: { x: col - 1, y: row } }, // Left
				{ dx: 1, dy: 0, wallCheck: { x: col + 1, y: row } }, // Right
			];

			// Only add paths if they don't extend into a wall
			directions.forEach(({ dx, dy, wallCheck }) => {
				if (!isWall(wallCheck.x, wallCheck.y)) {
					for (let i = 1; i <= SUBDIVISIONS / 2; i++) {
						subPathList.push({
							x: centerX + dx * i,
							y: centerY + dy * i,
						});
					}
				}
			});
		}
	}

	return subPathList;
};

const convertPosition = (pos) => {
	return {
		x: pos.x * SUBDIVISIONS + Math.floor(SUBDIVISIONS / 2),
		y: pos.y * SUBDIVISIONS + Math.floor(SUBDIVISIONS / 2),
	};
};

const subPathGrid = generateSubPathGrid();

const pathOut1 = [
	{
		x: 59,
		y: 81,
	},
	{
		x: 59,
		y: 82,
	},
	{
		x: 59,
		y: 83,
	},
	{
		x: 59,
		y: 84,
	},
	{
		x: 59,
		y: 85,
	},
	{
		x: 59,
		y: 86,
	},
	{
		x: 59,
		y: 87,
	},
	{
		x: 60,
		y: 87,
	},
	{
		x: 61,
		y: 87,
	},
	{
		x: 62,
		y: 87,
	},
	{
		x: 63,
		y: 87,
	},
	{
		x: 64,
		y: 87,
	},
	{
		x: 65,
		y: 87,
	},
	{
		x: 66,
		y: 87,
	},
	{
		x: 67,
		y: 87,
	},
	{
		x: 68,
		y: 87,
	},
	{
		x: 69,
		y: 87,
	},
	{
		x: 70,
		y: 87,
	},
	{
		x: 71,
		y: 87,
	},
	{
		x: 72,
		y: 87,
	},
	{
		x: 73,
		y: 87,
	},
	{
		x: 73,
		y: 88,
	},
	{
		x: 73,
		y: 89,
	},
	{
		x: 73,
		y: 90,
	},
	{
		x: 73,
		y: 91,
	},
	{
		x: 73,
		y: 92,
	},
	{
		x: 73,
		y: 93,
	},
	{
		x: 73,
		y: 94,
	},
	{
		x: 73,
		y: 95,
	},
	{
		x: 73,
		y: 96,
	},
	{
		x: 73,
		y: 97,
	},
	{
		x: 73,
		y: 98,
	},
	{
		x: 73,
		y: 99,
	},
	{
		x: 73,
		y: 100,
	},
	{
		x: 73,
		y: 101,
	},
	{
		x: 73,
		y: 102,
	},
	{
		x: 73,
		y: 103,
	},
	{
		x: 73,
		y: 104,
	},
	{
		x: 73,
		y: 105,
	},
	{
		x: 73,
		y: 106,
	},
	{
		x: 73,
		y: 107,
	},
	{
		x: 73,
		y: 108,
	},
	{
		x: 73,
		y: 109,
	},
	{
		x: 73,
		y: 110,
	},
	{
		x: 73,
		y: 111,
	},
	{
		x: 73,
		y: 112,
	},
	{
		x: 73,
		y: 113,
	},
	{
		x: 73,
		y: 114,
	},
	{
		x: 73,
		y: 115,
	},
	{
		x: 73,
		y: 116,
	},
	{
		x: 73,
		y: 117,
	},
	{
		x: 73,
		y: 118,
	},
	{
		x: 73,
		y: 119,
	},
	{
		x: 73,
		y: 120,
	},
	{
		x: 73,
		y: 121,
	},
	{
		x: 73,
		y: 122,
	},
	{
		x: 73,
		y: 123,
	},
	{
		x: 73,
		y: 124,
	},
	{
		x: 73,
		y: 125,
	},
	{
		x: 73,
		y: 126,
	},
	{
		x: 73,
		y: 127,
	},
	{
		x: 73,
		y: 128,
	},
	{
		x: 73,
		y: 129,
	},
	{
		x: 73,
		y: 130,
	},
	{
		x: 73,
		y: 131,
	},
	{
		x: 73,
		y: 132,
	},
	{
		x: 73,
		y: 133,
	},
	{
		x: 73,
		y: 134,
	},
	{
		x: 73,
		y: 135,
	},
	{
		x: 73,
		y: 136,
	},
	{
		x: 73,
		y: 137,
	},
	{
		x: 73,
		y: 138,
	},
	{
		x: 73,
		y: 139,
	},
	{
		x: 73,
		y: 140,
	},
	{
		x: 73,
		y: 141,
	},
	{
		x: 73,
		y: 142,
	},
	{
		x: 73,
		y: 143,
	},
	{
		x: 72,
		y: 143,
	},
	{
		x: 71,
		y: 143,
	},
	{
		x: 70,
		y: 143,
	},
	{
		x: 69,
		y: 143,
	},
	{
		x: 68,
		y: 143,
	},
	{
		x: 67,
		y: 143,
	},
	{
		x: 66,
		y: 143,
	},
	{
		x: 65,
		y: 143,
	},
	{
		x: 64,
		y: 143,
	},
	{
		x: 63,
		y: 143,
	},
	{
		x: 62,
		y: 143,
	},
	{
		x: 61,
		y: 143,
	},
	{
		x: 60,
		y: 143,
	},
	{
		x: 59,
		y: 143,
	},
	{
		x: 58,
		y: 143,
	},
	{
		x: 57,
		y: 143,
	},
	{
		x: 56,
		y: 143,
	},
	{
		x: 55,
		y: 143,
	},
	{
		x: 54,
		y: 143,
	},
	{
		x: 53,
		y: 143,
	},
	{
		x: 52,
		y: 143,
	},
	{
		x: 51,
		y: 143,
	},
];

const pathOut2 = [
	{
		x: 59,
		y: 93,
	},
	{
		x: 59,
		y: 92,
	},
	{
		x: 59,
		y: 91,
	},
	{
		x: 59,
		y: 90,
	},
	{
		x: 59,
		y: 89,
	},
	{
		x: 59,
		y: 88,
	},
	{
		x: 59,
		y: 87,
	},
	{
		x: 60,
		y: 87,
	},
	{
		x: 61,
		y: 87,
	},
	{
		x: 62,
		y: 87,
	},
	{
		x: 63,
		y: 87,
	},
	{
		x: 64,
		y: 87,
	},
	{
		x: 65,
		y: 87,
	},
	{
		x: 66,
		y: 87,
	},
	{
		x: 67,
		y: 87,
	},
	{
		x: 68,
		y: 87,
	},
	{
		x: 69,
		y: 87,
	},
	{
		x: 70,
		y: 87,
	},
	{
		x: 71,
		y: 87,
	},
	{
		x: 72,
		y: 87,
	},
	{
		x: 73,
		y: 87,
	},
	{
		x: 73,
		y: 86,
	},
	{
		x: 73,
		y: 85,
	},
	{
		x: 73,
		y: 84,
	},
	{
		x: 73,
		y: 83,
	},
	{
		x: 73,
		y: 82,
	},
	{
		x: 73,
		y: 81,
	},
	{
		x: 73,
		y: 80,
	},
	{
		x: 73,
		y: 79,
	},
	{
		x: 73,
		y: 78,
	},
	{
		x: 73,
		y: 77,
	},
	{
		x: 73,
		y: 76,
	},
	{
		x: 73,
		y: 75,
	},
	{
		x: 73,
		y: 74,
	},
	{
		x: 73,
		y: 73,
	},
	{
		x: 73,
		y: 72,
	},
	{
		x: 73,
		y: 71,
	},
	{
		x: 73,
		y: 70,
	},
	{
		x: 73,
		y: 69,
	},
	{
		x: 73,
		y: 68,
	},
	{
		x: 73,
		y: 67,
	},
	{
		x: 73,
		y: 66,
	},
	{
		x: 73,
		y: 65,
	},
	{
		x: 73,
		y: 64,
	},
	{
		x: 73,
		y: 63,
	},
	{
		x: 73,
		y: 62,
	},
	{
		x: 73,
		y: 61,
	},
	{
		x: 73,
		y: 60,
	},
	{
		x: 73,
		y: 59,
	},
	{
		x: 73,
		y: 58,
	},
	{
		x: 73,
		y: 57,
	},
	{
		x: 73,
		y: 56,
	},
	{
		x: 73,
		y: 55,
	},
	{
		x: 73,
		y: 54,
	},
	{
		x: 73,
		y: 53,
	},
	{
		x: 73,
		y: 52,
	},
	{
		x: 73,
		y: 51,
	},
	{
		x: 73,
		y: 50,
	},
	{
		x: 73,
		y: 49,
	},
	{
		x: 73,
		y: 48,
	},
	{
		x: 73,
		y: 47,
	},
	{
		x: 73,
		y: 46,
	},
	{
		x: 73,
		y: 45,
	},
	{
		x: 73,
		y: 44,
	},
	{
		x: 73,
		y: 43,
	},
	{
		x: 73,
		y: 42,
	},
	{
		x: 73,
		y: 41,
	},
	{
		x: 73,
		y: 40,
	},
	{
		x: 73,
		y: 39,
	},
	{
		x: 73,
		y: 38,
	},
	{
		x: 73,
		y: 37,
	},
	{
		x: 73,
		y: 36,
	},
	{
		x: 73,
		y: 35,
	},
	{
		x: 73,
		y: 34,
	},
	{
		x: 73,
		y: 33,
	},
	{
		x: 73,
		y: 32,
	},
	{
		x: 73,
		y: 31,
	},
	{
		x: 72,
		y: 31,
	},
	{
		x: 71,
		y: 31,
	},
	{
		x: 70,
		y: 31,
	},
	{
		x: 69,
		y: 31,
	},
	{
		x: 68,
		y: 31,
	},
	{
		x: 67,
		y: 31,
	},
	{
		x: 66,
		y: 31,
	},
	{
		x: 65,
		y: 31,
	},
	{
		x: 64,
		y: 31,
	},
	{
		x: 63,
		y: 31,
	},
	{
		x: 62,
		y: 31,
	},
	{
		x: 61,
		y: 31,
	},
	{
		x: 60,
		y: 31,
	},
	{
		x: 59,
		y: 31,
	},
	{
		x: 58,
		y: 31,
	},
	{
		x: 57,
		y: 31,
	},
	{
		x: 56,
		y: 31,
	},
	{
		x: 55,
		y: 31,
	},
	{
		x: 54,
		y: 31,
	},
	{
		x: 53,
		y: 31,
	},
	{
		x: 52,
		y: 31,
	},
	{
		x: 51,
		y: 31,
	},
];

const IserbaPacMan = ({ question, handleNext, setQuizResults }) => {
	const [player, setPlayer] = useState({ position: { x: 0, y: 0 } });
	const [ghosts, setGhosts] = useState([]);
	const playerRef = useRef(player);
	const ghostsRef = useRef(ghosts);

	const [items, setItems] = useState([]);
	const [situation, setSituation] = useState(null);
	const [splashScreenTitle, setSplashScreenTitle] = useState(
		"Equipez vous avant l'intervention suivante..."
	);
	const [splashScreenText, setSplashScreenText] = useState(
		"Recupérez les items necessaire a la bonne execution de l'intervention suivante. Attention, tous les equipements n'ont pas besoin d'être collectés..."
	);

	const [direction, setDirection] = useState({ dx: 0, dy: 0 });
	const [desiredDirection, setDesiredDirection] = useState({ dx: 0, dy: 0 });
	const [gameOver, setGameOver] = useState(false);
	const [gameOverTitle, setGameOverTitle] = useState("");
	const [gameOverText, setGameOverText] = useState("");
	const [gameStarted, setGameStarted] = useState(false);
	const [gameEnded, setGameEnded] = useState(false);

	const [collectedItems, setCollectedItems] = useState([]);
	const [missingItems, setMissingItems] = useState([]);

	const collectedItemsMemo = useMemo(() => collectedItems, [collectedItems]);
	const missingItemsMemo = useMemo(() => missingItems, [missingItems]);

	const [isLoading, setIsLoading] = useState(true);
	const [score, setScore] = useState(0);

	const playerProfile = useMemo(() => {
		return localStorage.getItem("player")
			? JSON.parse(localStorage.getItem("player"))
			: {};
	}, []);

	const playerSpriteSet =
		playerProfile?.avatar?.gender === "male"
			? playerSpriteSets.man_turquoise
			: playerSpriteSets.woman_purple;

	useEffect(() => {
		if (!question?.options) return;
		initVariables();
	}, [question]);

	const initVariables = () => {
		console.log("setting variables");
		setIsLoading(true);
		setScore(0);
		setGameEnded(false);
		setGameOver(false);
		setGameStarted(false);
		setSplashScreenTitle("Equipez vous avant l'intervention suivante...");
		setSplashScreenText(question.text);

		setSituation(iconMap[question.options.situation] || null);

		setPlayer({
			position: convertPosition(question.options.player.position),
		});

		setGhosts(
			question.options.ghosts.map((g) => ({
				...g,
				position: convertPosition(g.position),
				icon: iconMap[g.icon] || null,
				path: g.position.y === 11 ? pathOut1 : pathOut2,
			}))
		);
		ghostsRef.current = question.options.ghosts.map((g) => ({
			...g,
			position: convertPosition(g.position),
			icon: iconMap[g.icon] || null,
			path: g.position.y === 11 ? pathOut1 : pathOut2,
		}));

		setItems(
			question.options.items.map((item) => ({
				...item,
				position: convertPosition(item.position),
				icon: iconMap[item.icon] || null,
			}))
		);
		setMissingItems([]);
		setCollectedItems([]);
		setIsLoading(false);
	};

	const isWall = (x, y) => WALLS.some((wall) => wall.x === x && wall.y === y);
	const isSpawnZone = (x, y) =>
		SPAWN_ZONE.some((zone) => zone.x === x && zone.y === y);
	const isOnPath = (x, y) => {
		return subPathGrid.some((point) => point.x === x && point.y === y);
	};

	// Keep refs updated
	useEffect(() => {
		playerRef.current = player;
	}, [player]);

	useEffect(() => {
		ghostsRef.current = ghosts;
	}, [ghosts]);

	const startGame = () => {
		setDirection({ dx: 0, dy: 0 });
		setDesiredDirection({ dx: 0, dy: 0 });
		setCollectedItems([]);
		initVariables();
		setGameStarted(true);
		setGameOver(false);
		setGameEnded(false);
	};

	const playerEndGame = () => {
		setGameEnded(true);
		setGameStarted(false);
		let _missingItems = items.filter(
			(i) => i.isCorrect && !collectedItems.includes(i)
		);
		setMissingItems(_missingItems);
		setGameOverTitle(`Niveau terminé !`);
		setGameOverText(null);
	};

	const playerDead = () => {
		setGameOver(true);
		setGameStarted(false);
		setGameOverTitle(`Perdu !`);
		setGameOverText(`Ne vous laissez pas manger si facilement...`);
	};

	const handleNextLevel = () => {
		let score = collectedItems.reduce(
			(total, item) => total + (item.isCorrect ? 1 : -1),
			0
		);

		let answerValue = {
			collectedItems,
			missingItems,
		};
		setScore(score);
		setQuizResults((prev) => ({
			...prev,
			score: prev.score + score,
			responses: {
				...prev.responses,
				[question.id]: answerValue,
			},
		}));
		// set Reposnses
		handleNext();
	};

	const handleCollectItem = (item) => {
		setCollectedItems((prev) => {
			if (prev.some((i) => i.value === item.value)) return prev;
			return [...prev, item];
		});
		setItems((prev) => prev.filter((i) => i !== item));
	};

	useEffect(() => {
		const handleKeyDown = (e) => {
			if (!gameStarted || gameOver) return;
			const newDirection = {
				ArrowUp: { dx: 0, dy: -1 },
				ArrowDown: { dx: 0, dy: 1 },
				ArrowLeft: { dx: -1, dy: 0 },
				ArrowRight: { dx: 1, dy: 0 },
			}[e.key];

			if (newDirection) setDesiredDirection(newDirection);
		};

		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, [gameStarted, gameOver]);

	useEffect(() => {
		let touchStart = null;

		const handleTouchStart = (e) => {
			const touch = e.touches[0];
			touchStart = { x: touch.clientX, y: touch.clientY };
		};

		const handleTouchEnd = (e) => {
			if (!touchStart) return;

			const touch = e.changedTouches[0];
			const dx = touch.clientX - touchStart.x;
			const dy = touch.clientY - touchStart.y;
			const threshold = 20; // Minimum pixels to consider it a swipe

			if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > threshold) {
				if (dx > 0) setDesiredDirection({ dx: 1, dy: 0 }); // Right
				else setDesiredDirection({ dx: -1, dy: 0 }); // Left
			} else if (Math.abs(dy) > threshold) {
				if (dy > 0) setDesiredDirection({ dx: 0, dy: 1 }); // Down
				else setDesiredDirection({ dx: 0, dy: -1 }); // Up
			}

			touchStart = null;
		};

		document.addEventListener("touchstart", handleTouchStart, {
			passive: false,
		});
		document.addEventListener("touchend", handleTouchEnd, { passive: false });

		return () => {
			document.removeEventListener("touchstart", handleTouchStart);
			document.removeEventListener("touchend", handleTouchEnd);
		};
	}, [gameStarted, gameOver]);

	useEffect(() => {
		if (!gameStarted || gameOver) return;

		const movePlayer = () => {
			const newX = player.position.x + direction.dx;
			const newY = player.position.y + direction.dy;

			if (
				player.position.x === EXIT_POSITION.x &&
				player.position.y === EXIT_POSITION.y
			) {
				playerEndGame();
				return;
			}

			const playerCaught = ghosts.some(
				(ghost) =>
					player.position.x === ghost.position.x &&
					player.position.y === ghost.position.y
			);

			if (playerCaught) {
				playerDead();
			}

			// Check if player collects an equipment item within 3 cells
			const collectedItemIndex = items.findIndex((item) => {
				const distance =
					Math.abs(item.position.x - player.position.x) +
					Math.abs(item.position.y - player.position.y);

				return distance < 5;
			});

			if (collectedItemIndex !== -1) {
				const collectedItem = items[collectedItemIndex];
				handleCollectItem(collectedItem);
			}

			// Apply desired direction when possible
			if (
				isOnPath(
					player.position.x + desiredDirection.dx,
					player.position.y + desiredDirection.dy
				)
			) {
				setDirection(desiredDirection);
				setPlayer({
					position: {
						x: player.position.x + desiredDirection.dx,
						y: player.position.y + desiredDirection.dy,
					},
				});
				return;
			}

			// Move if not hitting a wall
			if (isOnPath(newX, newY)) {
				if (
					newX >= 0 &&
					newX < SUB_COLS &&
					newY >= 0 &&
					newY < SUB_ROWS &&
					isOnPath(newX, newY)
				) {
					setPlayer({ position: { x: newX, y: newY } });
				}
			}
		};

		const interval = setInterval(movePlayer, MOVEMENT_SPEED);
		return () => clearInterval(interval);
	}, [player, direction, gameStarted, gameOver, desiredDirection]);

	useEffect(() => {
		let interval;
		let timeout;
		let ghostIntervals = [];

		if (!gameStarted || gameOver) {
			clearTimeout(timeout);
			clearInterval(interval);
			ghostIntervals.forEach(clearInterval);
			return;
		}

		timeout = setTimeout(() => {
			ghostIntervals = ghostsRef.current.map((ghost) => {
				interval = setInterval(
					() => {
						setGhosts((prevGhosts) =>
							prevGhosts.map((g) =>
								g.color === ghost.color
									? {
											...g,
											path: findGhostPath(
												g.position,
												playerRef.current.position,
												(x, y) => isOnPath(x, y),
												(x, y) => isSpawnZone(x, y),
												g.color === "red",
												100,
												SPAWN_EXIT_POSITION
											),
									  }
									: g
							)
						);
					},
					ghost.color === "red" ? 2500 : 5000
				);

				return interval;
			});

			// Save cleanup function!
			return () => ghostIntervals.forEach(clearInterval);
		}, 4000);

		return () => {
			clearTimeout(timeout);
			clearInterval(interval);
			ghostIntervals.forEach(clearInterval);
		};
	}, [gameStarted, gameOver]);

	useEffect(() => {
		let interval;
		let timeout;

		if (!gameStarted || gameOver) {
			clearTimeout(timeout);
			clearInterval(interval);
			return;
		}

		timeout = setTimeout(() => {
			interval = setInterval(() => {
				const updatedGhosts = ghostsRef.current.map((ghost) => {
					if (ghost.path.length > 0) {
						const [nextMove, ...remainingPath] = ghost.path;

						const playerCaught =
							nextMove.x === playerRef.current.position.x &&
							nextMove.y === playerRef.current.position.y;

						if (playerCaught) {
							playerDead();
						}

						return {
							...ghost,
							position: nextMove,
							path: remainingPath,
						};
					}
					return ghost;
				});

				// ✅ Apply updates
				setGhosts(updatedGhosts);
			}, GHOST_SPEED);
		}, 2000 - 200 * parseInt(question.difficulty) || 0);

		return () => {
			clearTimeout(timeout);
			clearInterval(interval);
		};
	}, [gameStarted, gameOver]);

	if (isLoading) return <Loader />;

	return (
		<div
			className="relative w-full flex justify-center items-center"
			style={{
				height: "100%",
			}}
		>
			{!gameStarted && !gameOver && (
				<SplashScreen
					title={splashScreenTitle}
					text={splashScreenText}
					situation={situation}
					onStart={startGame}
					items={items}
				/>
			)}

			{(gameOver || gameEnded) && (
				<GameEndScreen
					title={gameOverTitle}
					text={gameOverText}
					levelCompleted={gameEnded}
					score={score}
					collectedItems={collectedItemsMemo}
					missingItems={missingItemsMemo}
					onNextLevel={handleNextLevel}
					onReplay={startGame}
				/>
			)}

			<div
				className="absolute flex items-center justify-center"
				style={{
					backgroundImage: `url(${borne_arcade})`,
					height: "100%",
					aspectRatio: `${COLS} / ${ROWS}`,
					left: "50%",
					transform: "translateX(-50%)",
					backgroundSize: "cover",
					backgroundPosition: "center",
					backgroundRepeat: "no-repeat",
				}}
			>
				{gameStarted && (
					<ScrollingItems
						items={question.options.items.map((item) => ({
							...item,
							position: convertPosition(item.position),
							icon: iconMap[item.icon] || null,
						}))}
					/>
				)}

				<div
					className="relative mt-[50px]"
					style={{
						scale: "0.8",
						width: "100%", // Ensures the container takes up full width of its parent
						height: "auto", // Ensures the container takes up full height of its parent
						display: "flex", // Flexbox ensures centering of children
						justifyContent: "center", // Center the game grid horizontally
						alignItems: "center", // Center the game grid vertically
					}}
				>
					{/* Subpath Overlay */}
					<div
						className=" pointer-events-none z-10"
						style={{
							width: "100%", // Ensure this takes up full height
							aspectRatio: `${COLS} / ${ROWS}`, // Maintain aspect ratio
						}}
					>
						{subPathGrid.map(({ x, y }, index) => (
							<div
								key={index}
								className="absolute w-10 h-10 bg-white"
								style={{
									left: `${(x / COLS / SUBDIVISIONS) * 100}%`,
									top: `${(y / ROWS / SUBDIVISIONS) * 100}%`,
									transform: `translate(calc(-50% + ${
										50 / SUBDIVISIONS
									}%), calc(-50% + ${50 / SUBDIVISIONS}%))`,
								}}
							></div>
						))}
					</div>

					{/* Player Component */}
					{player && (
						<div
							className="absolute w-12 h-12 z-20 "
							style={{
								left: `${(player.position.x / SUB_COLS) * 100}%`,
								top: `${(player.position.y / SUB_ROWS) * 100}%`,
								transform: `translate(calc(-50% + ${
									50 / SUBDIVISIONS
								}%), calc(-50% + ${50 / SUBDIVISIONS}%))`,
								willChange: "transform",
							}}
						>
							<div className="w-full h-full relative">
								<Player
									position={player.position}
									height={"100%"}
									width={"100%"}
									anchor={"top-left"}
									direction={direction}
									spriteSet={playerSpriteSet}
								/>
							</div>
						</div>
					)}

					{/* Ghosts */}
					{ghosts.map((ghost, index) => (
						<div
							key={index}
							className="absolute z-30 bg-contain bg-no-repeat h-12 w-12"
							style={{
								left: `${(ghost.position.x / SUB_COLS) * 100}%`,
								top: `${(ghost.position.y / SUB_ROWS) * 100}%`,
								transform: `translate(calc(-50% + ${
									50 / SUBDIVISIONS
								}%), calc(-50% + ${50 / SUBDIVISIONS}%))`,
								backgroundImage: ghost.icon ? `url(${ghost.icon})` : "none",
							}}
						/>
					))}

					{/* Items */}
					{items.map((item, index) => (
						<div
							key={index}
							className="absolute z-10 bg-contain bg-center bg-no-repeat h-12 w-12"
							style={{
								left: `${(item.position.x / SUB_COLS) * 100}%`,
								top: `${(item.position.y / SUB_ROWS) * 100}%`,
								transform: `translate(calc(-50% + ${
									50 / SUBDIVISIONS
								}%), calc(-50% + ${50 / SUBDIVISIONS}%))`,
								backgroundImage: item.icon ? `url(${item.icon})` : "none",
							}}
						/>
					))}

					{/* Exit Position */}
					{EXIT_POSITION && (
						<div
							className="absolute flex items-center justify-center bg-green-500 z-20 h-10 w-8"
							style={{
								left: `${(EXIT_POSITION.x / SUB_COLS) * 100}%`,
								top: `${(EXIT_POSITION.y / SUB_ROWS) * 100}%`,
								transform: `translate(calc(  ${
									50 / SUBDIVISIONS
								}%), calc( -50% + ${50 / SUBDIVISIONS}%))`,
							}}
						>
							<MdOutlineExitToApp size={30} color="white" />
						</div>
					)}

					{/* Main Grid Layer */}
					<div
						className="absolute top-0 grid border-0 gap-0"
						style={{
							width: "100%",
							height: "100%",
							gridTemplateColumns: `repeat(${COLS}, 1fr)`,
							gridTemplateRows: `repeat(${ROWS}, 1fr)`,
						}}
					>
						{[...Array(ROWS)].map((_, row) =>
							[...Array(COLS)].map((_, col) => {
								const isWallCell = isWall(col, row);

								return (
									<div
										key={`${row}-${col}`}
										className={`w-full h-full ${isWallCell ? "" : "bg-white"}`}
									/>
								);
							})
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default IserbaPacMan;
